function archivingConfirmationRequestDialog () {
  return {
    restrict: 'E',
    templateUrl: '/workflow/dialogs/archiving-confirmation-request/archiving-confirmation-request-dialog.html?$$REVISION$$'
  }
}

export { archivingConfirmationRequestDialog }
